import React from 'react';
import { Position } from './typesMyTeams';
import { translate } from '../../lib/translations';

interface PositionFilterProps {
  selectedPosition: Position;
  onPositionChange: (position: Position) => void;
  language: 'en' | 'fr';
}

export function PositionFilterMyTeams({
  selectedPosition,
  onPositionChange,
  language,
}: PositionFilterProps) {
  const positions: { value: Position; getTranslationKey: (value: Position) => string }[] = [
    { value: 'ALL', getTranslationKey: () => 'all.positions' },
    { value: 'FORWARD', getTranslationKey: () => 'forwards.crl' },
    { value: 'DEFENSE', getTranslationKey: () => 'defense' },
    { value: 'C', getTranslationKey: () => 'center' },
    { value: 'L', getTranslationKey: () => 'left.wing' },
    { value: 'R', getTranslationKey: () => 'right.wing' },
    { value: 'D', getTranslationKey: () => 'defenseman' },
  ];

  return (
    <div className="mb-4">
      <label className="form-label">{translate('filter.position', language)}</label>
      <select
        className="form-select"
        value={selectedPosition}
        onChange={(e) => onPositionChange(e.target.value as Position)}
      >
        {positions.map(({ value, getTranslationKey }) => (
          <option key={value} value={value}>
            {translate(getTranslationKey(), language)}
          </option>
        ))}
      </select>
    </div>
  );
}